import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { useStaticQuery, graphql } from 'gatsby';
import media from 'constants/styles/media';
import { Section } from 'components/layout/Section';
import { Header } from 'components/header';
import colors from 'constants/styles/colors';

const SLogos = styled.div`
    background: ${colors.gray_10};
    padding: 36px;
    border-radius: 16px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-around;
    gap: 48px;

    @media (max-width: ${media.mobile}) {
        flex-direction: column;
    }
`;

const SLogo = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const SLogoImg = styled.img<{ $height: number }>`
    display: block;
    width: auto;
    height: ${({ $height }) => $height}px;
`;

export const PartnersSection = () => {
    const { t } = useTranslation();

    const { partners } = useStaticQuery(graphql`
        query partners {
            partners: allFile(
                filter: { relativeDirectory: { eq: "partners" } }
                sort: { fields: relativePath, order: ASC }
            ) {
                nodes {
                    id
                    name
                    publicURL
                }
            }
        }
    `);

    return (
        <Section>
            <Header text={t('partners.header')} />

            <SLogos>
                {partners.nodes.map(
                    (node: { id: string; name?: string; publicURL?: string }, i: number) => {
                        if (!node.publicURL) {
                            return null;
                        }
                        const heights = [55, 55, 48];
                        return (
                            <SLogo key={node.id}>
                                <SLogoImg
                                    src={node.publicURL}
                                    alt={node.name ?? ''}
                                    $height={heights[i]}
                                />
                            </SLogo>
                        );
                    },
                )}
            </SLogos>
        </Section>
    );
};
